<nav>
    <ul class="wider-links" [ngClass]="{ active: active }">
        <li
            *ngIf="estimate?.IsTemplate && featureService.isAvailable('merchant')"
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{
                    active: currentRouteUrl === 'estimates.view.template-details',
                }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'template-details'])"
                >Template Details</a
            >
        </li>
        <li
            *ngIf="estimate?.AvailabilityScope === EstimateTemplateAvailabilityScope.Managed && featureService.isAvailable('merchant')"
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{
                    active: currentRouteUrl === 'estimates.view.accesscontrol',
                }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'accesscontrol'])"
                >Access Control</a
            >
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('estimates.view.details') &&
                permissionService.isAvailable('estimates.maintain-estimates.estimate-details')
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{
                    active: !readonly
                        ? currentRouteUrl === 'estimates.view.details'
                        : currentRouteUrl === 'estimates.customer-view.details',
                }"
                (click)="
                    onChangeRoute(
                        $event,
                        !readonly
                            ? ['/estimates', 'list', estimate.ID_Estimate, 'details']
                            : ['/estimates', estimate.ID_Estimate, 'customer', estimate.ID_Customer, 'details']
                    )
                ">
                Estimate Details
            </a>
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('estimates.view.plans-and-take-offs') &&
                permissionService.isAvailable('estimates.maintain-takeoffs.plans-and-takeoffs-menu')
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{
                    active: !readonly ? currentRouteUrl === 'plans-v2' : currentRouteUrl === 'estimates.customer-view.plans',
                }"
                (click)="
                    onChangeRoute(
                        $event,
                        !readonly
                            ? ['/estimates', 'list', estimate.ID_Estimate, 'plans-and-take-offs-v2']
                            : ['/estimates', estimate.ID_Estimate, 'customer', estimate.ID_Customer, 'plans']
                    )
                "
                >Plans & Takeoffs</a
            >
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('estimates.view.costings') &&
                permissionService.isAvailable('estimates.maintain-estimate-costings.costings-menu')
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{
                    active: !readonly
                        ? currentRouteUrl.includes('estimates.view.costings')
                        : currentRouteUrl === 'estimates.customer-view.costings',
                }"
                (click)="
                    onChangeRoute(
                        $event,
                        !readonly
                            ? ['/estimates', 'list', estimate.ID_Estimate, 'costings']
                            : ['/estimates', estimate.ID_Estimate, 'customer', estimate.ID_Customer, 'costings']
                    )
                ">
                Estimate Costings
            </a>
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('quoterequests') &&
                permissionService.isAvailable('request-for-quote.rfq-access.rfq-menu') &&
                !readonly
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{ active: currentRouteUrl.includes('estimates.view.quoterequests') }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'quoterequests'])"
                >Request for Quotes</a
            >
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('estimates.view.specifications') &&
                permissionService.isAvailable('estimates.maintain-specifications.specifications-menu') &&
                !readonly
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{ active: currentRouteUrl === 'estimates.view.specifications' }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'specifications'])"
                >Specifications</a
            >
        </li>
        <li
            *ngIf="permissionService.isAvailable('estimates.maintain-schedules.schedule-menu') && !readonly"
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{ active: currentRouteUrl === 'estimates.view.schedule' }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'schedule'])">
                Schedule
            </a>
        </li>
        <li
            *ngIf="
                featureService.isStateAvailable('estimates.view.print-quote') &&
                permissionService.isAvailable('estimates.maintain-quotes.quote-letter-menu') &&
                !readonly
            "
            [class.menubar-flow-icon-ic-chevron-s1]="showNavigationFlow">
            <a
                [ngClass]="{ active: currentRouteUrl === 'estimates.view.quote-templates2' }"
                (click)="onChangeRoute($event, ['/estimates', 'list', estimate.ID_Estimate, 'quote-templates2'])"
                >Quote Letter</a
            >
        </li>
    </ul>
</nav>
